import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export async function AddNewClient(
	clientName,
	clientEmail,
	clientPhoneNumber,
	setAlert,
	setSnackbarType,
	coBrokersSalesAgent
) {
	var currentUserId;

	if (coBrokersSalesAgent) {
		console.log('coBrokersSalesAgent', coBrokersSalesAgent);
		currentUserId = coBrokersSalesAgent;
	} else {
		currentUserId = firebase.auth().currentUser.uid;
	}
	var thisSalesAgentPointer;

	var doesThisClientExist = true;
	var shouldShowClient = false;
	let showClient;
	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData ' + JSON.stringify(snapData));

			var allKeys = snapData && Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];

			console.log('saveOrUpdateDocument key', thisSalesAgentPointer);
		});

	await firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		)
		.orderByChild('clientEmail')
		.equalTo(clientEmail)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			console.log('SnapData ', snapData);

			if (snapData === null) {
				doesThisClientExist = false;
			} else {
				shouldShowClient = true;
				showClient = Object.values(snapData)[0]?.showClient;
			}
		});

	if (doesThisClientExist === false) {
		setAlert('Client created successfully');
		setSnackbarType('success');
		var newClientRef = firebase
			.database()
			.ref(
				'kavtek_clients/' +
					PROJECT_CODE.projectCode +
					'/salesAgents/' +
					thisSalesAgentPointer +
					'/myClients'
			)
			.push();

		var thisClientJson = {
			appCode: '',
			clientEmail: clientEmail,
			clientKey: '',
			fullName: clientName,
			phoneNumber: clientPhoneNumber,
			clientCreatorId: currentUserId,
			showClient: true,
			timeOfAppointment: Date.now(),
			coBrokerId: coBrokersSalesAgent
				? firebase.auth().currentUser.uid
				: null,
		};

		await newClientRef.set(thisClientJson);
	}

	if (shouldShowClient === true && doesThisClientExist === true) {
		setAlert('Client created successfully');
		setSnackbarType('success');

		if (!showClient) {
			var clientKey;
			await firebase
				.database()
				.ref(
					'kavtek_clients/' +
						PROJECT_CODE.projectCode +
						'/salesAgents/' +
						thisSalesAgentPointer +
						'/myClients'
				)
				.orderByChild('clientEmail')
				.equalTo(clientEmail)
				.limitToFirst(1)
				.once('value', (snapshot) => {
					clientKey = Object.keys(snapshot.val())[0];
				});

			var existingClientRef = firebase
				.database()
				.ref(
					'kavtek_clients/' +
						PROJECT_CODE.projectCode +
						'/salesAgents/' +
						thisSalesAgentPointer +
						'/myClients/' +
						clientKey
				);

			existingClientRef.update({
				clientCreatorId: currentUserId,
				fullName: clientName,
				phoneNumber: clientPhoneNumber,
				showClient: true,
			});
		}
	}
}
